import { ViewModel,View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IStaticValueProvider } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/IStaticValueProvider";
import { idName } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/templateSelectorEditor/templateSelectorEditor-viewModel";
import  { TypeEditorView } from "./typeEditor-view"

export class TypeEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.selector = new selector(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new TypeEditorView();
    }
    public getTypeId(): string {
        return "VM-9142C4EC-32E6-436E-9500-5F4BED1DB3B8"
    }
    public set selector(v: selector) { this._selector = v; } public get selector(): selector { return this._selector;} private _selector: selector;
    
    setValue(v: string) {
        this.selector.selectById(v);
    }
    getValue(): string {
        if(this.selector.selectedItem==null){
            return null;
        }
        return this.selector.selectedItem.id;
    }

    requestConfirm() {
    }

}
export class selector extends SelectorBaseViewModel<idNameViewModel>{
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    private createIdName(id:string,name:string):idNameViewModel{
        let result = new idNameViewModel(this);
        result.id = id;
        result.title = name;
        return result;
    }
    protected loadData(): Promise<idNameViewModel[]> {
        let result:idNameViewModel[] = [
            this.createIdName("Content","Content"),
            this.createIdName("Combo","Combo"),
            this.createIdName("Table","Table"),
        ];
        return Promise.resolve(result);
    }
    
}
export class idNameViewModel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}
